    <p-toolbar styleClass="">
      <ng-template pTemplate="left">
        <span *ngIf="title" class="font-bold text-lg">{{ title }}</span>
      </ng-template>

      <ng-template pTemplate="right">
        <p-button icon="pi pi-refresh" label="Обновить" styleClass="p-button-success mr-2" (onClick)="reloadTable($event)"
                  pTooltip="Обновить таблицу документов" tooltipPosition="top"></p-button>

        <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)"
                  pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>

        <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="onExportData()"
                  pTooltip="Экспортировать список документов" tooltipPosition="top" [disabled]="!totalDocuments"></p-button>
      </ng-template>
    </p-toolbar>

    <p-table #ptable1 [value]="documentList"
             [rows]="10"
             [rowsPerPageOptions]="[10,25,50]"
             [loading]="loading"
             [showCurrentPageReport]="true"
             [totalRecords]="totalDocuments"
             [paginator]="true"
             currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} документов"
             sortMode="single"
             sortField="DOCDATE"
             sortOrder="-1"
             dataKey="DOCID"
             selectionMode="single"
             [(selection)]="selectedDocument"
             (onRowSelect)="onRowSelect($event)"
             rowExpandMode="single"
             [rowHover]="true"
             [resizableColumns]="true"
             (onFilter)="onFilterEvent($event)"
             styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
      <ng-template pTemplate="caption">
        <div class="flex flex-wrap align-items-center">
          <p-checkbox name="addProforma" [(ngModel)]="showProformaDocuments" [binary]="true" label="Показывать коммерческие предложения" (onChange)="onChangeDocumentType($event)"></p-checkbox>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn style="width: 5rem !important">...</th>
          <th pResizableColumn style="width: 10% !important">Документ</th>
          <th pResizableColumn pSortableColumn="DOCNUMBER" style="width: 11rem !important">Номер <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="DOCDATE" style="width: 10rem !important">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="LOCALCOMP" style="width: 10% !important">Продавец <p-sortIcon field="LOCALCOMP"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="AUTHOR" style="width: 10% !important">Автор <p-sortIcon field="AUTHOR"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="PARTNERNAMESTR" style="width: auto !important">Заказчик <p-sortIcon field="PARTNERNAMESTR"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="DOCSUM" style="width: 9rem !important">Сумма <p-sortIcon field="DOCSUM"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="PAYDSUM" style="width: 9rem !important">Оплачено <p-sortIcon field="PAYDSUM"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="SHIPSUM" style="width: 9rem !important">Отгружено <p-sortIcon field="SHIPSUM"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="DOCNOTE1" style="width: 10% !important">Пр. продавца <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="DOCNOTE2" style="width: 6% !important">Пр. покупателя <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
        </tr>

        <tr>
          <th pResizableColumn style="width: 5rem !important">...</th>
          <th pResizableColumn> </th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['DOCNUMBER']" (input)="ptable1.filter($event.target.value, 'DOCNUMBER', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['DOCDATE']" (input)="ptable1.filter($event.target.value, 'DOCDATE' , 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['LOCALCOMP']" (input)="ptable1.filter($event.target.value, 'LOCALCOMP', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['AUTHOR']" (input)="ptable1.filter($event.target.value, 'AUTHOR', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['PARTNERNAMESTR']" (input)="ptable1.filter($event.target.value, 'PARTNERNAMESTR', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['DOCSUM']" (input)="ptable1.filter($event.target.value, 'DOCSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['PAYDSUM']" (input)="ptable1.filter($event.target.value, 'PAYDSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['SHIPSUM']" (input)="ptable1.filter($event.target.value, 'SHIPSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['DOCNOTE1']" (input)="ptable1.filter($event.target.value, 'DOCNOTE1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
          <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf1['DOCNOTE2']" (input)="ptable1.filter($event.target.value, 'DOCNOTE2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-documentList let-expanded="expanded">
        <tr [pSelectableRow]="documentList"
            [class.futuredocs]="documentList.fd"
            [class.grayout]="documentList.go"
            [class.underline]="documentList.ps"
            [class.strikeout]="documentList.fs"
            [class.partiallypaiddoc]="documentList.pp"
            [class.notpaiddoc]="documentList.np"
            [class.fullypaiddoc]="documentList.fp"
            [class.todaydocuments]="documentList.td"
            [class.proformadoc]="(documentList.DOCTYPEID == 12)"
            [class.inorderdoc]="(documentList.DOCTYPEID == 2)"
            [class.banktransferdoc]="(documentList.DOCTYPEID == 9)"
            [class.purchorderdoc]="(documentList.DOCTYPEID == 10)"
            [class.yellowdoc]="(documentList.DOCTYPEID == 14)"
            [class.specdoc]="(documentList.DOCTYPEID == 7)"
            [class.shiporderdoc]="(documentList.DOCTYPEID == 4)"
            [class.invoicedoc]="(documentList.DOCTYPEID == 1)">
          <td style="width: 5rem !important">
            <button type="button" pButton pRipple [pRowToggler]="documentList"
                    class="p-button-text p-button-rounded p-button-plain"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
          </td>
          <td style="width: 10% !important">{{documentList.DOCNAME}}</td>
          <td style="width: 11rem !important">
            <a [routerLink]="['/edit-document', documentList.DOCTYPEID, documentList.DOCID]">{{documentList.DOCNUMBER}}</a>
          </td>
          <td style="width: 10rem !important">{{documentList.DOCDATE  | date:'dd.MM.yyyy'}}</td>
          <td style="width: 10% !important">{{documentList.LOCALCOMP}}</td>
          <td style="width: 10% !important; max-width: 250px !important ">{{documentList.AUTHOR}}</td>
          <td style="width: auto !important; max-width: 400px !important">
            <a [routerLink]="['/edit-client', documentList.DOCCLIENTSID]">{{documentList.PARTNERNAMESTR}}</a>
          </td>
          <td style="max-width: 10rem !important; text-align: right">{{documentList.DOCSUM | number:'1.2-2' }}</td>
          <td style="max-width: 10rem !important; text-align: right">{{documentList.PAYDSUM | number:'1.2-2' }}</td>
          <td style="max-width: 10rem !important; text-align: right">{{documentList.SHIPSUM | number:'1.2-2' }}</td>
          <td style="width: 10% !important; max-width: 200px !important "><input pInputText type="text" [(ngModel)]="documentList.DOCNOTE1" readonly alt="{{documentList.DOCNOTE1}}"></td>
          <td style="width: 6% !important; max-width: 200px !important "><input pInputText type="text" [(ngModel)]="documentList.DOCNOTE2" readonly alt="{{documentList.DOCNOTE2}}"></td>
        </tr>
      </ng-template>

      <ng-template pTemplate="rowexpansion" let-documentList>
        <tr>
          <td colspan="12">
            <app-document-content-table [selectedDocumentId]="documentList.DOCID" [showFooterTotal]="true"></app-document-content-table>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td style="max-width: 10rem !important; text-align: right">{{totalInvoiceSum | number:'1.2-2' }}</td>
          <td style="max-width: 10rem !important; text-align: right">{{totalPaidSum | number:'1.2-2' }}</td>
          <td style="max-width: 10rem !important; text-align: right">{{totalShippedSum | number:'1.2-2' }}</td>
          <td></td>
          <td></td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="12">На сегодня документов нет</td>
        </tr>
      </ng-template>
    </p-table>
    <div class="fluid grid">
      <div class="col">
      </div>
    </div>
